import * as THREE from 'three'
import Experience from './Experience.js'
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js'
import  gsap  from "gsap"

export default class Camera
{
    constructor()
    {
        this.experience = new Experience()
        this.sizes = this.experience.sizes
        this.isVertical=this.sizes.isVertical
        this.scene = this.experience.scene
        this.sceneGroup = this.experience.sceneGroup
        this.canvas = this.experience.canvas
        this.debug = this.experience.debug
        this.fovMulti=this.sizes.width/this.sizes.height
        this.actualFov=30
        
        this.orbit=false
        this.easing='power3.inOut'

        // this.setControls()
        // Debug
        if(this.debug.active)
        {
            this.debugFolder = this.debug.ui.addFolder('camera')
        }
        this.setInstance()

    }

    setInstance()
    {
        // this.cameraGroup = new THREE.Group()
        // this.scene.add(this.cameraGroup)
        // this.instance = new THREE.PerspectiveCamera(this.actualFov/this.fovMulti, this.sizes.width / this.sizes.height,1, 500)
        // // this.instance.position.set(0,0,-30)
        // // console.log(this.instance)
        // this.cameraGroup.position.set(0,0.5,4)
        // // this.instance.lookAt(0,0.5,0);
        // this.cameraGroup.add(this.instance)



        // this.cameraGroup = new THREE.Group()
        // this.scene.add(this.cameraGroup)
        this.instance = new THREE.PerspectiveCamera(this.actualFov/this.fovMulti, this.sizes.width / this.sizes.height,1, 500)
        this.instance.position.set(0,0.5,4)
        // console.log(this.instance)
        // this.cameraGroup.position.set(0,0.5,4)
        // this.instance.lookAt(0,0.5,0);
        // this.cameraGroup.add(this.instance)
        this.scene.add(this.instance)

        if(this.debug.active)
        {
            this.debugFolder
                .add(this.sceneGroup.position, 'x')
                .name('camera x')
                .min(-10)
                .max(10)
                .step(0.01)
                .onChange(()=>{this.update()}),
                this.debugFolder
                .add(this.sceneGroup.position, 'y')
                .name('camera y')
                .min(-10)
                .max(10)
                .step(0.01)
                .onChange(()=>{this.update()})
                this.debugFolder
                .add(this.sceneGroup.position, 'z')
                .name('camera z')
                .min(-10)
                .max(10)
                .step(0.01)
                .onChange(()=>{this.update()})
        }
        // console.log(this.cameraGroup)
   }

    setControls()
    {
        this.controls = new OrbitControls(this.instance, this.canvas)
        this.controls.enableDamping = true
    }

    resize()
    {
        this.instance.aspect = this.sizes.width / this.sizes.height
        // this.instance.updateProjectionMatrix()
        this.fovMulti=this.sizes.width/this.sizes.height
        this.instance.fov=this.actualFov/this.fovMulti
        this.instance.updateProjectionMatrix()
        //  console.log(this.fovMulti)
    }

    update()
    {
        // this.instance.lookAt(0,0.5,0);

        // this.controls.update()
    }
    posizione1(){
        if(!this.sizes.isVertical && !this.sizes.isSmartphone){
            gsap.to(this.sceneGroup.position,{x:0,duration:2,ease:this.easing})
            gsap.to(this.sceneGroup.position,{z:-5,duration:2,ease:this.easing})
            this.actualFov=30
            gsap.to(this.instance,{fov:this.actualFov/this.fovMulti,duration:2,ease:this.easing,onUpdate:()=>{this.instance.updateProjectionMatrix()}})
        } else{
            gsap.to(this.sceneGroup.position,{x:0,duration:2,ease:this.easing})
            gsap.to(this.sceneGroup.position,{z:-5,duration:2,ease:this.easing})
            this.actualFov=25
            gsap.to(this.instance,{fov:this.actualFov/this.fovMulti,duration:2,ease:this.easing,onUpdate:()=>{this.instance.updateProjectionMatrix()}})
        }
    }
    posizione2(){
        if(!this.sizes.isVertical && !this.sizes.isSmartphone){
            gsap.to(this.sceneGroup.position,{x:2,duration:2,ease:this.easing})
            gsap.to(this.sceneGroup.position,{z:-11,duration:2,ease:this.easing})
            this.actualFov=30
            gsap.to(this.instance,{fov:this.actualFov/this.fovMulti,duration:2,ease:this.easing,onUpdate:()=>{this.instance.updateProjectionMatrix()}})

        } else{
            this.posizione1()
        }
    }
    posizione3(){
        if(!this.sizes.isVertical && !this.sizes.isSmartphone){
            gsap.to(this.sceneGroup.position,{x:0,duration:2,ease:this.easing})
            gsap.to(this.sceneGroup.position,{z:-1,duration:2,ease:this.easing})
            this.actualFov=60
            gsap.to(this.instance,{fov:this.actualFov/this.fovMulti,duration:2,ease:this.easing,onUpdate:()=>{this.instance.updateProjectionMatrix()}})
        } else{
            gsap.to(this.sceneGroup.position,{x:0,duration:2,ease:this.easing})
            gsap.to(this.sceneGroup.position,{z:-1,duration:2,ease:this.easing})
            this.actualFov=45
            gsap.to(this.instance,{fov:this.actualFov/this.fovMulti,duration:2,ease:this.easing,onUpdate:()=>{this.instance.updateProjectionMatrix()}})
        }

    }
}